import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Component } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl";

class LockInfoDialog extends Component {
  render() {
    const { intl, surveyName, lockByUser, lockFrom, showReadOnlyDialog, hideReadOnlyDialog } = this.props;
    let timeLock = lockFrom ? (
      <FormattedDate
        value={new Date(lockFrom)}
        year="numeric"
        month="2-digit"
        day="2-digit"
        hour="numeric"
        minute="2-digit"
        second="2-digit"
      />
    ) : (
      "x.y.zzzz"
    );

    return (
      <Modal size="lg" show={showReadOnlyDialog} className="read-only">
        <Modal.Body>
          <Alert variant="warning">
            <FontAwesomeIcon icon={faExclamationTriangle} size={"lg"} />
            <p>
              {intl.formatMessage(
                { id: "user.surveyView.editing.read.only1" },
                {
                  surveyName,
                  lockByUser
                }
              )}
              {timeLock}
              <FormattedMessage id="user.surveyView.editing.read.only2" />
            </p>
          </Alert>
          
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={hideReadOnlyDialog.bind(showReadOnlyDialog, false)} block>
            <FormattedMessage id="confirmDialog.ok" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

LockInfoDialog.propTypes = {
  intl: PropTypes.object,
  surveyName: PropTypes.string,
  hideReadOnlyDialog: PropTypes.func,
  showReadOnlyDialog: PropTypes.bool
};

export default injectIntl(LockInfoDialog);
